import React from 'react';
import styled, { keyframes } from 'styled-components';
import { prop, remSize } from '../../../theme';

const skBounce = keyframes`
  0%, 100% {
    transform: scale(0.0);
  }
  50% {
    transform: scale(1.0);
  }
`;
const Container = styled.div`
  &&& {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${prop('backgroundColor')};
  }
`;
const LoaderWrapper = styled.div`
  &&& {
    width: ${remSize(80)};
    height: ${remSize(80)};
    position: relative;
  }
`;
const LoaderCircle = styled.div`
  &&& {
    width: 100%;
    height: 100%;
    border-radius: 80%;
    background-color: ${prop('logoColor')};
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    animation: ${skBounce} 2s infinite ease-in-out;
    &:nth-child(2) {
      animation-delay: -1s;
    }
  }
`;

export const Loader = () => (
  <Container data-testid="loader">
    <LoaderWrapper>
      <LoaderCircle />
      <LoaderCircle />
    </LoaderWrapper>
  </Container>
);

// Line-height-sized sibling of `Loader`, for annotating a control or a line of text rather than
// replacing a region: same two-ball skBounce animation, no full-size container, no background.
// The balls take `currentColor` so the spinner reads correctly against whatever it sits in (the
// toast sets its own themed foreground colour) instead of hardcoding the logo colour.
const InlineWrapper = styled.span`
  &&& {
    width: ${remSize(18)};
    height: ${remSize(18)};
    position: relative;
    display: inline-block;
    flex: none;
    vertical-align: middle;
  }
`;
const InlineCircle = styled.span`
  &&& {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    animation: ${skBounce} 2s infinite ease-in-out;
    &:nth-child(2) {
      animation-delay: -1s;
    }
  }
`;

export const InlineLoader = () => (
  <InlineWrapper data-testid="inline-loader" aria-hidden="true">
    <InlineCircle />
    <InlineCircle />
  </InlineWrapper>
);
